import { InputSwitch, InputSwitchStatus } from "@constellation-academy/epic-ui";
import { Tag } from "primereact/tag";
import { useTranslation } from "@i18n/hooks";
import { type featureTogglesScreen_FeatureToggleFragment$data } from "@relay/featureTogglesScreen_FeatureToggleFragment.graphql";

type FeatureToggleActivationCellProps = {
	featureToggle: featureTogglesScreen_FeatureToggleFragment$data;
	isEditing: boolean;
	onActiveChange: (isActive: boolean) => void;
};

export const FeatureToggleActivationCell = ({
	featureToggle,
	isEditing,
	onActiveChange,
}: FeatureToggleActivationCellProps) => {
	const { t } = useTranslation("common");

	if (featureToggle.data.kind === "experimentalMode") {
		const isExperimentalModeActive = featureToggle.data.isActive === true;

		return (
			<Tag
				value={t(
					isExperimentalModeActive
						? "featureToggles.experimentalModeActive"
						: "featureToggles.experimentalModeInactive",
				)}
				severity={isExperimentalModeActive ? "success" : "info"}
			/>
		);
	}

	return (
		<InputSwitch
			checked={featureToggle.data.isActive}
			status={isEditing ? InputSwitchStatus.Loading : undefined}
			onChange={onActiveChange}
		/>
	);
};
